import React, { useState, useEffect } from 'react';

const MobileCta = (props) => {
  const content = props.content || {};
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, 2000); // 2000 ms = 2 seconds.

    return () => clearTimeout(timer); // cleanup
  }, []);

  return (
    <div
      className={`mobileCta md:!hidden transition-transform duration-500 ${show ? 'translate-y-0' : 'translate-y-full'
        }`}
    >
      <button onClick={() => window.open(content.mobileCta.url, '_self')}
        className="flex justify-center items-center w-full mx-auto px-8 h-[53px] bg-[#266b37] hover:bg-green-800 text-white text-lg font-semibold rounded-[4px] shadow-lg transition duration-300">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          fill="currentColor"
          className="w-5 h-5 mx-3"
        >
          <path d="M16 0C7.163 0 0 7.163 0 16c0 2.837.74 5.566 2.14 7.98L0 32l8.293-2.12A15.92 15.92 0 0016 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm7.68 22.24c-.32.9-1.86 1.74-2.56 1.86-.7.12-1.54.16-2.48-.16-.58-.18-1.32-.42-2.26-.82-3.98-1.72-6.56-5.96-6.76-6.24-.2-.28-1.6-2.12-1.6-4.04 0-1.92 1-2.86 1.4-3.26.36-.36.8-.44 1.06-.44h.76c.24 0 .56-.08.88.68.32.76 1.12 2.64 1.22 2.84.1.2.16.44.04.72-.12.28-.18.44-.36.68-.2.24-.36.4-.56.64-.2.24-.4.48-.18.88.24.4 1.06 1.72 2.28 2.8 1.56 1.4 2.86 1.84 3.26 2.04.4.2.64.16.88-.08.24-.24 1-1.16 1.26-1.56.24-.4.52-.32.88-.2.36.12 2.28 1.08 2.68 1.28.4.2.68.28.8.44.12.16.12.92-.2 1.82z" />
        </svg>
        {content.mobileCta.label}
      </button>
    </div>
  );
};

export default MobileCta;
